import React, { PropsWithChildren } from 'react';

import styled from '@emotion/styled';

import { ThemeColorKey } from '../theme/type';

const ChipContainer = styled.div<{
  color?: ThemeColorKey;
  background?: ThemeColorKey;
}>`
  width: fit-content;
  padding: ${({ theme }) => theme.spacing('0500')};
  background: ${({ theme, background = 'surface' }) => theme.color[background]};
  border-radius: ${({ theme }) => theme.shape.corner['0500']};
  color: ${({ theme, color = 'onSurface' }) => theme.color[color]};
  font: ${({ theme }) => theme.typography.mono.regular};
  font-size: ${({ theme }) => theme.typescale.size['0875']};
`;

export interface IChipProps {
  color?: ThemeColorKey;
  background?: ThemeColorKey;
  className?: string;
}

export const Chip = ({
  color,
  background,
  children,
  className,
}: PropsWithChildren<IChipProps>) => {
  return (
    <ChipContainer className={className} color={color} background={background}>
      {children}
    </ChipContainer>
  );
};
